import { defineStore } from "pinia";
import ApiService from "@/services/ApiService";
import { INotificationParams } from "@/modules/Notification/types";

export const useNotificationStore = defineStore("notificationStore", {
  state: () => ({
    notifications: [],
    headerNotifications: [],
    notificationSingle: {},
    loading: false,
    loadingSingle: false,
    unreadNotifications: 0,
    headerNotificationsCount: 0,
    notificationsCount: 0,
    showNotificationDetail: false,
    notificationFrom: "",
    size: {
      header: 5,
      page: 10,
    },
  }),
  actions: {
    getNotifications(params?: INotificationParams) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        ApiService.query("/notification/user-notifications/", { params })
          .then((res) => {
            this.unreadNotifications = res?.data?.unread_count;
            this.notifications = res?.data?.notifications?.results;
            this.notificationsCount = res?.data?.notifications?.total;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    getHeaderNotifications(params?: INotificationParams) {
      return new Promise((resolve, reject) => {
        ApiService.query("/notification/user-notifications/", { params })
          .then((res) => {
            this.unreadNotifications = res?.data?.unread_count;
            this.headerNotifications = res?.data?.notifications?.results;
            this.headerNotificationsCount = res?.data?.notifications?.total;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    readAllNotifications() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        ApiService.post("/notification/read-all-notifications/")
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    getNotificationsSingle(id: number, from: string) {
      this.notificationSingle = {};
      this.loadingSingle = true;
      this.notificationFrom = from;
      return new Promise((resolve, reject) => {
        ApiService.get(`/notification/user-notifications/${id}/`)
          .then((res) => {
            this.notificationSingle = res?.data;
            this.showNotificationDetail = true;
            resolve(res?.data);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.loadingSingle = false;
          });
      });
    },
  },
});
